import { useCallback, useMemo } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import I18n from 'I18n';
import { completedDateOptions } from '../../constants/filters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  value
}) => {
  return value && value in completedDateOptions ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.completedDate.labelWithValue",
    options: {
      value: completedDateOptions[value].getText().toLowerCase()
    }
  }) : I18n.text('learningCenter.myTeam.filters.completedDate.label');
};
const CompletedDateFilter = ({
  value,
  onChange
}) => {
  const options = useMemo(() => {
    return Object.values(completedDateOptions).map(option => ({
      text: option.getText(),
      value: option.presetId
    }));
  }, []);
  const handleChange = useCallback(event => {
    const selected = event.target.value || undefined;
    onChange(selected);
  }, [onChange]);
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      value
    },
    buttonUse: "transparent",
    "data-test-id": "completed-date-filter",
    menuWidth: 300,
    minimumSearchCount: 0,
    multi: false,
    onChange: handleChange,
    options: options,
    searchable: true,
    value: value !== null && value !== void 0 ? value : null
  });
};
export default CompletedDateFilter;